/** PermittingPortalRoute — pass-through; PermittingPortal owns its masthead. */
import PermittingPortal from "./PermittingPortal";

export default function PermittingPortalRoute() {
  return <PermittingPortal />;
}
